import { supabase } from '../../../lib/supabase';
import type { ProviderSyncSettings, ResolvedSyncSettings } from './types';

const DISABLED: ProviderSyncSettings = { enabled: false, calendarId: null, connected: false };

/**
 * Risolve in modo SINCRONO (al submit) le impostazioni di sync Google + Microsoft
 * dell'utente passato, RITORNANDO i valori invece di fare setState.
 *
 * Motivo: lo stato React caricato in modo async (loadSyncSettings) può essere
 * vuoto/stantio al momento del submit → si finirebbe per scrivere col token
 * dell'assegnatario su un calendario di cui non è owner (403), o per saltare
 * del tutto la sync. Fonte: LeadStatusUpdateDrawer.tsx:493-506 (che risolveva
 * SOLO Google), estesa qui ai campi Microsoft già selezionati nella stessa
 * query a LeadStatusUpdateDrawer.tsx:465-469 — così anche il ramo Microsoft
 * smette di dipendere da uno stato React potenzialmente stantio (bug race).
 *
 * UNA sola query su user_profiles per entrambi i provider.
 * Su errore query o userId null: entrambi i provider spenti (comportamento
 * storico di LeadStatusUpdateDrawer.tsx:496).
 */
export async function resolveUserSyncSettings(
  userId: string | null
): Promise<ResolvedSyncSettings> {
  if (!userId) return { google: { ...DISABLED }, microsoft: { ...DISABLED } };

  const { data } = await supabase
    .from('user_profiles')
    .select(
      'sync_activities, sync_activities_calendar_id, google_account_connected, microsoft_account_connected, microsoft_sync_activities, microsoft_sync_activities_calendar_id'
    )
    .eq('id', userId)
    .single();

  if (!data) return { google: { ...DISABLED }, microsoft: { ...DISABLED } };

  return {
    google: {
      enabled: !!data.sync_activities,
      calendarId: data.sync_activities_calendar_id || null,
      connected: !!data.google_account_connected,
    },
    microsoft: {
      enabled: !!data.microsoft_sync_activities,
      calendarId: data.microsoft_sync_activities_calendar_id || null,
      connected: !!data.microsoft_account_connected,
    },
  };
}
